<template>
  <!-- Fila con las dos cards de configuracion -->
  <v-row class="ma-0">
    <v-col cols="12" md="6">
      <v-card shaped elevation="2">
        <v-card-title class="titulo_card">{{ $t('Imágenes del centro') }}</v-card-title>
        <v-card-text>
          <!-- Mensaje informativo para observar la web de ejemplo  -->
          <div class="container_info_azul">
            <span>{{ $t('Sube las imágenes de tu centro de belleza que quieres que aparezcan en tu web.') }}</span>
          </div>
          <FileDrop @files-selected="add_images" />

          <v-row class="ma-0 mb-2">
            <v-col
                class="pa-1"
                cols="12"
                sm="4"
                md="3"
                v-for="(img, index) in imagenes_centro"
                :key="index"
            >
              <v-card>
                <v-card-text class="pa-2 text-center">
                  <div style="height:125px">
                    <v-img class="img_centro" :src="img.name" :alt="img.name" contain />
                  </div>
                  <v-btn fab icon small @click="delete_imagen(img.name)" :title="$t('Eliminar')">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                  <v-icon v-if="img.opts.principal" color="primary" :title="$t('Imagen principal')">mdi-star</v-icon>
                  <v-btn fab icon small v-else @click="set_principal(img.name)" :title="$t('Hacer imagen principal')">
                    <v-icon>mdi-star-outline</v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card shaped elevation="2">
        <v-card-title class="titulo_card">{{ $t('Banners') }}</v-card-title>
        <v-card-text>
          <!-- Mensaje informativo para observar la web de ejemplo  -->
          <div class="container_info_azul">
            <span>{{ $t('En esta sección puedes configurar las diferentes imágenes que aparecerán como banner principal, fondo del horario y fondo de la oferta.') }}</span>
          </div>
          <!-- Banner principal -->
          <v-expansion-panels focusable class="mb-5">
            <v-expansion-panel>
              <v-expansion-panel-header class="titulo_buscador">{{ $t('Banner principal') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-0">
                  <v-col
                      cols="6"
                      v-for="(current_imagen, index) in data_form.imagenes_web_banner"
                      :key="index">
                    <v-img
                        @click="select_image('banner', current_imagen.value)"
                        :src="current_imagen.text"
                        :class="{'selected': current_imagen.value === configuracion_marketing.web_imagen_banner, 'pointer': true}"
                        max-width="100%"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="9">
                    <v-file-input
                        v-model="web_imagen_banner"
                        :label="$t('Adjuntar imagen')"
                        outlined dense
                        prepend-icon="mdi-image"
                        accept="image/*"
                        :clearable="false"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="3">
                    <v-btn @click="upload_image('banner')" style="height: 38px;" color="primary" block small :disabled="!web_imagen_banner">
                      <v-icon small>mdi-upload</v-icon>
                      <span class="ml-1">{{ $t('Subir') }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- Fin del Banner principal -->
          <!-- Banner horario -->
          <v-expansion-panels focusable class="mb-5">
            <v-expansion-panel>
              <v-expansion-panel-header class="titulo_buscador">{{ $t('Banner del horario') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-0">
                  <v-col
                      cols="6"
                      v-for="(current_imagen, index) in data_form.imagenes_web_horario"
                      :key="index">
                    <v-img
                        @click="select_image('horario', current_imagen.value)"
                        :src="current_imagen.text"
                        :class="{'selected': current_imagen.value === configuracion_marketing.web_imagen_horario, 'pointer': true}"
                        max-width="100%"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="9">
                    <v-file-input
                        v-model="web_image_horario"
                        :label="$t('Adjuntar imagen')"
                        outlined dense
                        prepend-icon="mdi-image"
                        accept="image/*"
                        :clearable="false"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="3">
                    <v-btn @click="upload_image('horario')" style="height: 38px;" color="primary" block small :disabled="!web_image_horario">
                      <v-icon small>mdi-upload</v-icon>
                      <span class="ml-1">{{ $t('Subir') }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- Fin del Banner horario -->
          <!-- Banner oferta -->
          <v-expansion-panels focusable class="mb-5">
            <v-expansion-panel>
              <v-expansion-panel-header class="titulo_buscador">{{ $t('Banner de la oferta') }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-0">
                  <v-col
                      cols="6"
                      v-for="(current_imagen, index) in data_form.imagenes_web_oferta"
                      :key="index">
                    <v-img
                        @click="select_image('oferta', current_imagen.value)"
                        :src="current_imagen.text"
                        :class="{'selected': current_imagen.value === configuracion_marketing.web_imagen_oferta, 'pointer': true}"
                        max-width="100%"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="9">
                    <v-file-input
                        v-model="web_image_oferta"
                        :label="$t('Adjuntar imagen')"
                        outlined dense
                        prepend-icon="mdi-image"
                        accept="image/*"
                        :clearable="false"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="3">
                    <v-btn @click="upload_image('oferta')" style="height: 38px;" color="primary" block small :disabled="!web_image_oferta">
                      <v-icon small>mdi-upload</v-icon>
                      <span class="ml-1">{{ $t('Subir') }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- Fin del Banner oferta -->
        </v-card-text>
      </v-card>
    </v-col>
    <!-- Boton de guardar datos -->
    <v-btn @click="$emit('on_click_save')" color="primary" block small>
      <v-icon small>mdi-content-save</v-icon>
      <span class="ml-1">{{ $t('Guardar') }}</span>
    </v-btn>
  </v-row>
</template>


<script>
export default {
  name: "ImagenesPaginaWeb",
  props: {
    configuracion_marketing: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    imagenes_centro: [],

    // Variables para subir las imágenes
    web_imagen_banner: null,
    web_image_horario: null,
    web_image_oferta: null,

    data_form: {
      imagenes_web_banner: [],
      imagenes_web_horario: [],
      imagenes_web_oferta: []
    }
  }),

  methods: {


    /**
     * Añade las imagenes
     * @param imagenes
     */
    async add_images(imagenes) {
      try {
        const item = await this.$store.dispatch(`centro/add_images`, {
          imagenes: imagenes
        })

        this.imagenes_centro = this.$store.state.centro.centro.imagenes_absolute_path

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
        this.$snotify.error(
          this.$t("Error al realizar la acción"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Establece la imagen como principal
     * @param nombre
     */
    async set_principal(nombre) {
      try {
        const item = await this.$store.dispatch(`centro/imagen_principal`, {
          id: this.id,
          nombre: nombre
        })

        this.imagenes_centro = this.$store.state.centro.centro.imagenes_absolute_path

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.$emit('on_change')
      } catch (err) {
        this.$snotify.error(
          this.$t("Error al realizar la acción"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Elimina una imagen
     * @param nombre
     */
    async delete_imagen(nombre) {
      try {
        const item = await this.$store.dispatch(`centro/eliminar_imagen`, {
          id: this.id,
          nombre: nombre
        });

        this.imagenes_centro = this.$store.state.centro.centro.imagenes_absolute_path

        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        this.$emit('on_change')
      } catch (err) {
        this.$snotify.error(
          this.$t("Error al realizar la acción"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    async upload_image(target){
      try {
        let image;
        if(target === 'banner'){
          image = this.web_imagen_banner
        } else if(target === 'horario') {
          image = this.web_image_horario
        } else if(target === 'oferta') {
          image = this.web_image_oferta
        } else {
          return
        }

        const configuracion_marketing = await this.$store.dispatch('configuraciones/upload_banner_web', {
          target,
          image
        })
        await this.get_data_form()
        this.$emit('on_update_banner', configuracion_marketing)

        this.web_imagen_banner = null
        this.web_image_horario = null
        this.web_image_oferta = null

      }catch (err){}
    },

    /**
     * Recupera las imágenes de los banners que se pueden seleccionar
     * @returns {Promise<void>}
     */
    async get_data_form() {
      try {
        this.data_form = await this.$store.dispatch('configuraciones/get_form', 'marketing')
      } catch (err) {}
    },

    /**
     * Selecciona la imagen
     * @param tipo (principal, horario u oferta)
     * @param url (url de la imagen)
     */
    select_image(tipo, url){
      switch (tipo){
        case 'banner':
          this.configuracion_marketing.web_imagen_banner = url
          break;
        case 'horario':
          this.configuracion_marketing.web_imagen_horario = url
          break;
        case 'oferta':
          this.configuracion_marketing.web_imagen_oferta = url
          break;
      }
    },

  },

  mounted() {
    this.get_data_form()
    this.imagenes_centro = this.$store.state.centro.centro.imagenes_absolute_path
  }
}
</script>


<style lang="scss" scoped>
.selected{
  border: 7px solid #006da7;
}
.img_centro {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: block;
}
</style>
